<template>
    <v-card v-if="voucher">
        <v-card-title class="secondary--text headline" primary-title>
            Resubmeter cupom fiscal
            <span class="subheading grey--text">
              Insira uma nova chave ou edite a antiga chave de acesso
            </span>
        </v-card-title>
        <v-form lazy-validation v-model="valid" ref="form">
            <v-card-text class="pt-0 pb-0">
                <v-text-field
                    v-model="cupom_model.chave_cupom"
                    label="Chave de acesso"
                    outline
                    counter="44"
                    :rules="[
                        v => !!v || 'Insira uma chave de acesso válida',
                        v => v.length === 44 || 'A chave de acesso deve ter 44 dígitos'
                    ]"
                    mask="#### #### #### #### #### #### #### #### #### #### ####"
                    required
                ></v-text-field>
            </v-card-text>
            <v-card-text class="pt-0">
              <v-text-field
                v-model.lazy="codigo"
                v-if="rendering"
                label="Número do cupom"
                v-money="money"
                outline
                :rules="[
                    v => !!v || ''
                ]"
                readonly
                hide-details
                required
              ></v-text-field>
            </v-card-text>
        </v-form>
        <v-card-actions class="pt-0">
            <v-btn flat block color="success lighten-1" @click="vincularCupom()">
                CONFIRMAR
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  props: ['voucher'],
  data () {
    return {
      valid: false,
      money: {
        thousands: '.',
        precision: 0
      },
      rendering: true,
      codigo: null,
      cupom_model: {
        codigo_cupom: null,
        chave_cupom: null
      }
    }
  },
  directives: { money: VMoney },
  watch: {
    'cupom_model.chave_cupom' (val) {
      if (val.length >= 34) {
        this.cupom_model.codigo_cupom = val.substr(25, 9)
        this.codigo = parseInt(val.substr(25, 9))
      } else {
        this.cupom_model.codigo_cupom = null
        this.codigo = null
      }
      this.rendering = false
      this.$nextTick(() => {
        this.rendering = true
      })
    },
    voucher (val) {
      if (val) {
        this.carregarDados()
      }
    }
  },
  mounted () {
    this.carregarDados()
  },
  methods: {
    carregarDados () {
      this.cupom_model = { ...this.voucher }
    },
    vincularCupom () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('editarCupomFiscal', { cupom_model: this.cupom_model, id_voucher: this.voucher.id_voucher }).then(() => {
          this.voucher.cupom_inserido = true
          this.$emit('fechar')
        }).catch(() => {
          this.$emit('fechar')
        })
      }
    }
  }
}
</script>
